module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "datepicker",
    staticClass: "form-control",
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-332969ea","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DatePicker.vue
// module id = 435
// module chunks = 1